import {harmonyOne} from "wagmi/chains";

const config = {
  chainId: harmonyOne.id,
  walletConnectProjectId: '2727249b64744ae33e0c9bbdf3e5bcba',
  wrappedOneContractAddress: '0xcf664087a5bb0237a0bad6742852ec6c8d69a27a',
  universalRouterAddress: '0xdAa5Bf7004e33789ce13A2bBE620953B55608B8b'
}

export default config
